//
// Copyright 2020 DXOS.org
//
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any, file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import { file_dxos_field_options } from "../field_options_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import { file_dxos_halo_credentials } from "../halo/credentials_pb.js";
import { file_dxos_echo_timeframe } from "./timeframe_pb.js";
/**
 * Describes the file dxos/echo/object.proto.
 */
export const file_dxos_echo_object = /*@__PURE__*/ fileDesc("ChZkeG9zL2VjaG8vb2JqZWN0LnByb3RvEhBkeG9zLmVjaG8ub2JqZWN0IqgGCgpFY2hvT2JqZWN0EhEKCW9iamVjdF9pZBgBIAEoCRIxCgRtZXRhGAIgASgLMh4uZHhvcy5lY2hvLm9iamVjdC5NdXRhdGlvbk1ldGFIAIgBARI6CgdnZW5lc2lzGAogASgLMiQuZHhvcy5lY2hvLm9iamVjdC5FY2hvT2JqZWN0LkdlbmVzaXNIAYgBARI8CghzbmFwc2hvdBgNIAEoCzIlLmR4b3MuZWNoby5vYmplY3QuRWNob09iamVjdC5TbmFwc2hvdEgCiAEBEjgKCW11dGF0aW9ucxgOIAMoCzIlLmR4b3MuZWNoby5vYmplY3QuRWNob09iamVjdC5NdXRhdGlvbhpLCgdHZW5lc2lzEhIKCm1vZGVsX3R5cGUYAiABKAkSGgoNbW9kZWxfdmVyc2lvbhgDIAEoCUgAiAEBQhAKDl9tb2RlbF92ZXJzaW9uGowBCghTbmFwc2hvdBIUCgdkZWxldGVkGAEgASgISACIAQESFgoJcGFyZW50X2lkGAIgASgJSAGIAQESLgoFbW9kZWwYCiABKAsyFC5nb29nbGUucHJvdG9idWYuQW55QgSA9AMBSAKIAQFCCgoIX2RlbGV0ZWRCDAoKX3BhcmVudF9pZEIICgZfbW9kZWwaoQIKCE11dGF0aW9uEjEKBG1ldGEYASABKAsyHi5keG9zLmVjaG8ub2JqZWN0Lk11dGF0aW9uTWV0YUgAiAEBEhYKCXBhcmVudF9pZBgKIAEoCUgBiAEBEkEKBmFjdGlvbhgLIAEoDjIsLmR4b3MuZWNoby5vYmplY3QuRWNob09iamVjdC5NdXRhdGlvbi5BY3Rpb25IAogBARIuCgVtb2RlbBgMIAEoCzIULmdvb2dsZS5wcm90b2J1Zi5BbnlCBID0AwFIA4gBASIrCgZBY3Rpb24SCAoETk9PUBAAEgoKBkRFTEVURRABEgsKB1JFU1RPUkUQAkIHCgVfbWV0YUIMCgpfcGFyZW50X2lkQgkKB19hY3Rpb25CCAoGX21vZGVsQgcKBV9tZXRhQgoKCF9nZW5lc2lzQgsKCV9zbmFwc2hvdCKAAgoMTXV0YXRpb25NZXRhEisKCGZlZWRfa2V5GAEgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleUgAiAEBEhAKA3NlcRgCIAEoBUgBiAEBEi0KCm1lbWJlcl9rZXkYAyABKAsyFC5keG9zLmtleXMuUHVibGljS2V5SAKIAQESPAoJdGltZWZyYW1lGAQgASgLMiQuZHhvcy5lY2hvLnRpbWVmcmFtZS5UaW1lZnJhbWVWZWN0b3JIA4gBARISCgpjbGllbnRfdGFnGAUgAygJQgsKCV9mZWVkX2tleUIGCgRfc2VxQg0KC19tZW1iZXJfa2V5QgwKCl90aW1lZnJhbWViBnByb3RvMw", [file_google_protobuf_any, file_google_protobuf_descriptor, file_dxos_field_options, file_dxos_keys, file_dxos_halo_credentials, file_dxos_echo_timeframe]);
/**
 * Describes the message dxos.echo.object.EchoObject.
 * Use `create(EchoObjectSchema)` to create a new message.
 */
export const EchoObjectSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_object, 0);
/**
 * Describes the message dxos.echo.object.EchoObject.Genesis.
 * Use `create(EchoObject_GenesisSchema)` to create a new message.
 */
export const EchoObject_GenesisSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_object, 0, 0);
/**
 * Describes the message dxos.echo.object.EchoObject.Snapshot.
 * Use `create(EchoObject_SnapshotSchema)` to create a new message.
 */
export const EchoObject_SnapshotSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_object, 0, 1);
/**
 * Describes the message dxos.echo.object.EchoObject.Mutation.
 * Use `create(EchoObject_MutationSchema)` to create a new message.
 */
export const EchoObject_MutationSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_object, 0, 2);
/**
 * @generated from enum dxos.echo.object.EchoObject.Mutation.Action
 */
export var EchoObject_Mutation_Action;
(function (EchoObject_Mutation_Action) {
    /**
     * @generated from enum value: NOOP = 0;
     */
    EchoObject_Mutation_Action[EchoObject_Mutation_Action["NOOP"] = 0] = "NOOP";
    /**
     * @generated from enum value: DELETE = 1;
     */
    EchoObject_Mutation_Action[EchoObject_Mutation_Action["DELETE"] = 1] = "DELETE";
    /**
     * @generated from enum value: RESTORE = 2;
     */
    EchoObject_Mutation_Action[EchoObject_Mutation_Action["RESTORE"] = 2] = "RESTORE";
})(EchoObject_Mutation_Action || (EchoObject_Mutation_Action = {}));
/**
 * Describes the enum dxos.echo.object.EchoObject.Mutation.Action.
 */
export const EchoObject_Mutation_ActionSchema = /*@__PURE__*/ enumDesc(file_dxos_echo_object, 0, 2, 0);
/**
 * Describes the message dxos.echo.object.MutationMeta.
 * Use `create(MutationMetaSchema)` to create a new message.
 */
export const MutationMetaSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_object, 1);
//# sourceMappingURL=object_pb.js.map